module.exports = __webpack_public_path__ + "assets/img/steering-wheel.24152e86.svg";